module.exports = __webpack_public_path__ + "4c2cbdd6af8e5d085824a063a1cd9ea0.jpg";